import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { QuicklinkModule } from 'ngx-quicklink';
import { QuillConfig, QuillConfigModule } from 'ngx-quill';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { paginatorIntlConfig } from './application/paginator-configuration';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { DebugInterceptor } from './interceptors/debug.interceptor';
import { SideMainNavModule } from './layouts/side-main-nav/side-main-nav.module';
import { IconService } from './services/icon.service';

registerLocaleData(ptBr);

const modules: QuillConfigModule = {
  syntax: false,
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction

    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],

    ['clean'],                                         // remove formatting button

    ['link']                         // link and image, video
  ]
};
const quillConfig: QuillConfig = { modules: modules };

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    QuicklinkModule,
    AppRoutingModule,
    HttpClientModule,
    SideMainNavModule,
    QuillConfigModule.forRoot(quillConfig),
    SweetAlert2Module.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DebugInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide: APP_INITIALIZER, deps: [IconService], useFactory: (iconService: IconService) => function () { iconService.init() }, multi: true },
    { provide: MatPaginatorIntl, useValue: paginatorIntlConfig }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
